import "./ServiceHero.css";
import { ArrowRight } from "lucide-react";
import heroBg from "../assets/HeroService.png";

const WebDevHero = () => {
  return (
    <section
      className="webdev-hero"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="webdev-hero-overlay"></div>

      <div className="webdev-hero-content">

        <span className="webdev-badge">
          OUR SERVICES
        </span>

        <h1>
          Solutions Designed For <span>Every Stage</span><br />
          Of Your Business
        </h1>

        <p>
          Whether you're launching a startup, scaling your business, or
          modernizing existing systems, we offer flexible technology
          packages tailored to your goals.
        </p>

        <div className="webdev-buttons">

          <a href="#offers" className="primary-btn">
            Explore Packages
            <ArrowRight size={20} />
          </a>

          <a href="#contact" className="secondary-btn">
            Contact Us
          </a>

        </div>

      </div>
    </section>
  );
};

export default WebDevHero;